// extracted by mini-css-extract-plugin
module.exports = {"nextStepBtn":"passengers-list_nextStepBtn__2mUB1","tableContainer":"passengers-list_tableContainer__3goRu"};